import { imgproxyHealthyAtom, proxyMediaUrl, reportImgproxyFailure } from '@/atoms/imgproxy'
import { cn } from '@/lib/utils'
import { getDefaultStore } from 'jotai'
import { HugeiconsIcon } from '@hugeicons/react'
import { HeartIcon } from '@hugeicons/core-free-icons'
import { HTMLAttributes, useEffect, useState } from 'react'
import { Emoji as EmojiT } from '@nostr/gadgets/lists'

const store = getDefaultStore()

export default function Emoji({
  emoji,
  classNames
}: Omit<HTMLAttributes<HTMLDivElement>, 'className'> & {
  emoji: EmojiT | string
  classNames?: {
    text?: string
    img?: string
  }
}) {
  const [hasError, setHasError] = useState(false)
  const [emojiSrc, setEmojiSrc] = useState(typeof emoji === 'string' ? '' : emoji.url)

  useEffect(() => {
    if (typeof emoji !== 'string') {
      const load = async () => {
        const healthy = await store.get(imgproxyHealthyAtom)
        if (healthy) {
          setEmojiSrc(await proxyMediaUrl(emoji.url, 'rs:fit:40:40'))
        } else {
          setEmojiSrc(emoji.url)
        }
      }
      load()
    }
  }, [typeof emoji === 'string' ? '' : emoji.url])

  if (typeof emoji === 'string') {
    return emoji === '+' ? (
      <HugeiconsIcon
        icon={HeartIcon}
        className={cn('size-5 text-red-400 fill-red-400', classNames?.img)}
      />
    ) : (
      <span className={cn('whitespace-nowrap', classNames?.text)}>{emoji}</span>
    )
  }

  if (hasError) {
    return (
      <span className={cn('whitespace-nowrap', classNames?.text)}>{`:${emoji.shortcode}:`}</span>
    )
  }

  return (
    <img
      src={emojiSrc}
      alt={emoji.shortcode}
      draggable={false}
      className={cn('inline-block size-5 rounded-sm pointer-events-none', classNames?.img)}
      onLoad={() => {
        setHasError(false)
      }}
      onError={async () => {
        const { imgproxyUrl } = window.hallway?.universe || {}
        const wasUsingImgproxy = !!(imgproxyUrl && emojiSrc?.startsWith(imgproxyUrl))
        const healthy = await store.get(imgproxyHealthyAtom)

        if (wasUsingImgproxy && healthy) {
          reportImgproxyFailure()
          if (typeof emoji !== 'string') {
            setEmojiSrc(emoji.url)
          }
          return
        }

        setHasError(true)
      }}
    />
  )
}
